import request from '@/utils/request'

export function getDeliveryReportList(data) {
  return request.post('/delivery-report/list', data)
}

export function getDeliveryReportDetailList(data) {
  return request.post('/delivery-report/detail', data)
}

export function getDeliveryOrderList(data) {
  return request.post('/delivery-order/list', data)
}

export function addDeliveryOrder(data) {
  return request.post('/delivery-order/add', data)
}

export function deleteDeliveryOrder(data) {
  return request.post('/delivery-order/delete', data)
}

export function updateEmpOfDeliveryOrder(data) {
  return request.post('/delivery-order/update-emp', data)
}

export function printedDeliveryOrder(data) {
  return request.post('/delivery-order/delivery-printed', data)
}

export function unlinkSellOrder(data) {
  return request.post('/delivery-order/unlink-sell', data)
}



// WEBPACK FOOTER //
// ./src/api/delivery/order.js